module.exports = fox._r("images/ajax-loader.gif", __webpack_public_path__ + "images/ajax-loader.gif");


//////////////////
// WEBPACK FOOTER
// ./images/ajax-loader.gif
// module id = 978
// module chunks = 4